import { api, getList } from "./api";
import type { Seuil } from "../types/seuil";

// Récupérer tous les seuils
export async function getSeuils(): Promise<Seuil[]> {
  return getList<Seuil>("/seuils/");
}

// Récupérer un seuil par ID
export async function getSeuil(id: string): Promise<Seuil> {
  const res = await api.get(`/seuils/${id}/`);
  return res.data;
}

// Créer un seuil
export async function createSeuil(payload: Partial<Seuil>): Promise<Seuil> {
  const res = await api.post("/seuils/", payload);
  return res.data;
}

// Mettre à jour un seuil
export async function updateSeuil(id: string, payload: Partial<Seuil>): Promise<Seuil> {
  const res = await api.put(`/seuils/${id}/`, payload);
  return res.data;
}

// Supprimer un seuil
export async function deleteSeuil(id: string): Promise<void> {
  await api.delete(`/seuils/${id}/`);
}
